import React from "react";
import { useRoutes } from "react-router-dom";
import { AppRoutes } from "./routes/router";
export default function App() {
  return useRoutes(AppRoutes);
}
